<template>
  <div class="Assessment login">
    <TopNavBar navtitle="考官评审"></TopNavBar>
    <div class="areabatchinfo" @click="showAreaBatch">
      <h1>
        <b>{{ EA_Name }}</b
        >{{ EB_Name }}
        <i class="iconfont icon-arrow-down"></i>
      </h1>
      <p v-if="AllCount > 0">
        共有{{ AllCount }}名考生
        <van-tag round type="success">已评审：{{ ReviewCount }}人</van-tag>
        <van-tag round type="danger"
          >未评审：{{ AllCount - ReviewCount }}人</van-tag
        >
      </p>
    </div>
    <div class="Assessbox">
      <div class="areabatch" v-if="isareabatch">
        <ul>
          <li>
            <h2>批次选择</h2>
            <div class="bitem">
              <span
                v-for="(item, index) in ExamBatchList"
                :key="index"
                :name="item.EB_ID"
                :class="quertList.EB_ID == item.EB_ID ? 'radiochecked' : ''"
                @click="onCheckedbatch(item)"
                >{{ item.EB_Name }}</span
              >
            </div>
          </li>
          <li>
            <h2>地区选择</h2>
            <div class="aitem">
              <span
                v-for="(item, index) in ExamAreaList"
                :key="index"
                :name="item.EA_ID"
                :class="quertList.EA_ID == item.EA_ID ? 'radiochecked' : ''"
                @click="onChecked(item)"
                >{{ item.EA_Name }}</span
              >
            </div>
          </li>
        </ul>
        <van-button
          type="danger"
          @click="next"
          class="next"
          round
          block
          native-type="submit"
          >确认选择</van-button
        >
      </div>
      <div class="searchbox" v-show="show">
        <van-search
          @search="next"
          v-model="quertList.QueryParma"
          placeholder="请输入考生姓名/身份证号/准考证号"
        />
        <van-dropdown-menu>
          <van-dropdown-item
            @change="next"
            v-model="quertList.MID"
            :options="MajorsList"
          />
          <van-dropdown-item
            @change="next"
            v-model="quertList.GID"
            :options="GradesList"
          />
          <van-dropdown-item
            @change="next"
            v-model="quertList.IsReview"
            :options="option3"
          />
        </van-dropdown-menu>
        <!-- 考生信息 -->
        <div class="examineeInfo enrolllist">
          <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            finished-text="没有更多了"
            @load="onLoad"
            :offset="10"
          >
            <van-cell v-for="item in ExamFromList" :key="item.EF_ID">
              <ul class="examinfo">
                <img class="papers" :src="item.Photo" alt />
                <li>
                  <label for>姓名：</label>
                  <span>{{ item.Name }}</span>
                </li>
                <li>
                  <label for>编号：</label>
                  <span>{{ item.ExamNO }}</span>
                </li>
                <li>
                  <label for>专业：</label>
                  <span class="warning">{{ item.Majors.MName }}</span>
                </li>
                <li>
                  <label for>级别：</label>
                  <span class="warning">{{ item.Grades.GName }}</span>
                </li>
                <li
                  v-if="
                    !item.ExaminerReviewList ||
                      item.ExaminerReviewList.length == 0
                  "
                >
                  <label for>状态：</label>
                  <span class="warning">未评审</span>
                </li>
                <li
                  v-if="
                    item.ExaminerReviewList &&
                      item.ExaminerReviewList.length > 0
                  "
                >
                  <label for>状态：</label>
                  <span class="succeed">已评审</span>
                </li>
                <li
                  class="spaceBetween"
                  v-if="
                    !item.ExaminerReviewList ||
                      item.ExaminerReviewList.length == 0
                  "
                >
                  <van-button
                    type="info"
                    size="small"
                    :to="'/AssessDetails?EF_ID=' + item.EF_ID"
                  >
                    <em class="iconfont icon-pinglun1"></em>开始评审
                  </van-button>
                </li>
                <li
                  class="spaceBetween"
                  v-if="
                    item.ExaminerReviewList &&
                      item.ExaminerReviewList.length > 0
                  "
                >
                  <van-button
                    type="info"
                    block
                    size="small"
                    :to="'/AssessDetails?EF_ID=' + item.EF_ID"
                  >
                    <em class="iconfont icon-pinglun1"></em>查看详情
                  </van-button>
                </li>
              </ul>
            </van-cell>
          </van-list>
          <div
            class="no-data"
            v-if="!this.ExamFromList || ExamFromList.length == 0"
          >
            <van-empty description="暂无信息" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import TopNavBar from "@/components/TopNavBar.vue";
import {
  GetExamAreaList,
  GetALLExamBatchMenuList,
  GetMajorsList,
  GetALLGradesList
} from "@/api/exam";
import { GetExaminerHaveExamFromList } from "@/api/examiner";

const defaultQueryList = {
  PageSize: 20,
  PageIndex: 1,
  EB_ID: null,
  EA_ID: null,
  MID: null,
  GID: null,
  IsReview: null,
  QueryParma: null
};
export default {
  components: {
    TopNavBar
  },
  data() {
    return {
      ExamAreaList: null,
      MajorsList: [],
      GradesList: [],
      ExamBatchList: null,
      isareabatch: true,
      quertList: Object.assign({}, defaultQueryList),
      EB_Name: "全部",
      EA_Name: "全部",
      value: "",
      show: false,
      option3: [
        { text: "是否评审", value: null },
        { text: "未评审", value: "0" },
        { text: "已评审", value: "1" }
      ],
      ExamFromList: [],
      total: 0, //总共的数据条数
      loading: false,
      finished: false,
      AllCount: 0,
      ReviewCount: 0
    };
  },
  created() {
    this.GetInitList();
  },
  methods: {
    GetExaminerHaveExamFromList() {
      GetExaminerHaveExamFromList(this.quertList).then(res => {
        let rows = res.listData; //请求返回当页的列表
        this.loading = false;
        this.total = res.totalCount;
        if (rows == null || rows.length === 0) {
          // 加载结束
          this.finished = true;
          return;
        }
        // 数据合并
        this.ExamFromList = this.ExamFromList.concat(rows);
        if (this.ExamFromList.length >= this.total) {
          this.finished = true;
        }
        if (this.quertList.PageIndex == 1) {
          this.AllCount = Number(res.OtherMsg.AllCount);
          this.ReviewCount = Number(res.OtherMsg.ReviewCount);
        }
      });
    },
    //滚动加载时触发，
    onLoad() {
      this.quertList.PageIndex++;
      this.GetExaminerHaveExamFromList();
    },
    async GetInitList() {
      //获取所有考区信息
      await GetExamAreaList({ IsPub: 1 }).then(res => {
        this.ExamAreaList = res.listData;
      });
      // 获取所有专业
      await GetMajorsList().then(res => {
        this.MajorsList.push({ text: "所有专业", value: null });
        res.listData.forEach(element => {
          this.MajorsList.push({ text: element.MName, value: element.MID });
        });
      });
      // 获取所有等级
      await GetALLGradesList().then(res => {
        this.GradesList.push({ text: "所有等级", value: null });
        res.listData.forEach(element => {
          this.GradesList.push({ text: element.GName, value: element.GID });
        });
      });
      //获取所有考试批次信息
      await GetALLExamBatchMenuList().then(res => {
        this.ExamBatchList = res.listData;
      });
    },
    onCheckedbatch(ExamBatch) {
      if (this.quertList.EB_ID == ExamBatch.EB_ID) {
        this.quertList.EB_ID = null;
        this.EB_Name = "全部";
      } else {
        this.quertList.EB_ID = ExamBatch.EB_ID;
        this.EB_Name = ExamBatch.EB_Name;
      }
    },
    onChecked(ExamArea) {
      if (this.quertList.EA_ID == ExamArea.EA_ID) {
        this.quertList.EA_ID = null;
        this.EA_Name = "全部";
      } else {
        this.quertList.EA_ID = ExamArea.EA_ID;
        this.EA_Name = ExamArea.EA_Name;
      }
    },
    next() {
      this.isareabatch = false;
      this.show = true;
      this.ExamFromList = [];
      this.quertList.PageIndex = 1;
      this.GetExaminerHaveExamFromList();
    },
    showAreaBatch() {
      this.isareabatch = true;
      this.show = false;
    },
    onSelect(item) {
      this.show = false;
      Toast(item.name);
      this.tvalue = item.name;
    }
  }
};
</script>

<style>
.Assessment {
  background: url(../assets/kgkp.jpg) #04080f top no-repeat;
  min-height: 80vh;
  width: 100%;
}
.Assessbox {
  background: #fff;
  border-radius: 15px 15px 0 0;
  width: 100%;
  margin: 5vh auto 0;
  padding: 10px;
  box-sizing: border-box;
}
.Assessbox .enrolllist {
  width: 100%;
}
.Assessbox .van-tabs .van-hairline--top-bottom::after,
.Assessbox .van-tabs .van-hairline-unset--top-bottom::after {
  border: 0;
}

.Assessbox .enrolllist .van-list .examinfo img {
  position: absolute;
  left: 1%;
  border-radius: 5px;
}
.Assessbox .enrolllist .van-list .examinfo li {
  margin-left: 23vw;
}
.enrolllist ul li.spaceBetween {
  justify-content: flex-start;
}
.enrolllist ul li.spaceBetween button {
  margin-right: 3%;
  width: 47%;
}
.enrolllist .van-list .van-cell {
  padding: 0;
}
.enrolllist .van-list .van-cell::after {
  border-bottom: 0;
}
.areabatchinfo h1 {
  width: 90%;
  border-radius: 30px;
  margin: 10px auto;
  padding: 10px 0;
}
.areabatchinfo h1 b {
  margin-right: 15px;
}
.areabatchinfo p {
  color: #fff;
  font-size: 3vw;
}
.areabatchinfo p span {
  margin: 0 3px;
}
.areabatch .next {
  margin: 35px auto;
  padding: 25px 0;
  background: linear-gradient(to left, #fb905b, #ef2158);
  border: 0;
}
.areabatch ul li h2 {
  text-align: left;
  color: #555;
  font-weight: 500;
  padding: 20px 0 5px;
}
.areabatch ul li .aitem,
.areabatch ul li .bitem {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
.areabatch ul li .aitem span,
.areabatch ul li .bitem span {
  background: #e1e1e1;
  border-radius: 5px;
  padding: 15px 10px;
  margin: 1% 1% 2% 0;
  color: #333;
  font-size: 3.2vw;
}
.areabatch ul li .aitem span.radiochecked,
.areabatch ul li .bitem span.radiochecked {
  background: linear-gradient(to right, #fb8c5b, #f02658);
  color: #fff;
}
.areabatch ul li .aitem span {
  width: 26%;
}
.areabatch ul li .bitem span {
  width: 100%;
  display: flex;
  align-items: center;
  display: inline-block;
  text-align: center;
  padding: 15px 0;
}
</style>
